const {
  handleColorScroll,
  renderDiscount,
  multipleProducts,
  handleProductImage
} = await import(`./configurator-utils.js?v=${Date.now()}`);
const { pricing } = await import(`./pricing.js?v=${Date.now()}`);
class ConfiguratorVariant extends HTMLElement {
  constructor() {
    super();
    let products = this.querySelector("#js-products").innerHTML;
    let buttons = this.querySelectorAll(".colors-grid__item");
    let colorGrid = this.querySelector(".colors-grid");
    let select = this.querySelector(".variant-select");
    let layer = this.querySelector(".configurator-variant").dataset.layer;
    let imageLayer = this.querySelector(".configurator-variant").dataset.imagelayer;
    let nextButton = this.querySelector(".button-holder__button");
    let previousButton = this.querySelector(".button-holder__button--previous");
    let buttonRow = document.querySelector(".button-row__fade");
    let pricingElement = this.querySelector(".js-pricing");
    let param = select.getAttribute("data-select");
    console.log("variant");
    const handleFallbackImage = () => {
      let fallbackImage = document.querySelector(".configurator-media__inner").dataset.fallbackImage;
      let baseImageLayer = document.querySelector(".image-layer-1");
      baseImageLayer.removeAttribute("srcset");
      baseImageLayer.src = fallbackImage;
    };
    const setUrlParams = (selectElement, variant, product) => {
      console.log(selectElement, variant, product);
      let param2 = selectElement.getAttribute("data-select");
      let url = new URL(window.location.href);
      url.searchParams.set(param2, `${product.id}-${variant.id}`);
      window.history.replaceState({}, "", url);
    };
    const setLocalstorage = (variant) => {
      let currentConfig = sessionStorage.getItem("configuratorConfig") ? JSON.parse(sessionStorage.getItem("configuratorConfig")) : [];
      currentConfig[layer] = variant;
      if (currentConfig) {
        sessionStorage.setItem("configuratorConfig", JSON.stringify(currentConfig));
      }
      if (currentConfig[1] == null) {
        handleFallbackImage();
      }
    };
    const prefSizeCheck = (size) => {
      let prefSizeArray = ["160X200X30", "180X200X30", "50X"];
      return prefSizeArray.includes(size);
    };
    const handleVariantSelect = (product, select2, discount, trigger) => {
      let options_not_disabled = select2.querySelectorAll("option:not([disabled])");
      let options = select2.querySelectorAll("option");
      let availableVariants = product.variants.filter((variant) => {
        return variant.available;
      });
      console.log("options", options, options_not_disabled);
      console.log("availableVariants", availableVariants);
      if (options_not_disabled.length > 0) {
        setLocalstorage(availableVariants.find((variant) => {
          return variant.title.includes(options_not_disabled[0].value);
        }));
      }
      if (options_not_disabled.length == 0) {
        setLocalstorage(null);
        select2.querySelectorAll("option")[0].selected = true;
      }
      document.querySelector('.colors-grid__item[data-id="' + product.id + '"]').classList.remove("disabled");
      if (select2.querySelectorAll("option[disabled]").length == options.length) {
        document.querySelector('.colors-grid__item[data-id="' + product.id + '"]').classList.add("disabled");
      }
      fetch(`/products/${product.handle}`).then((res) => res.text()).then((htmlString) => {
        let parser = new DOMParser();
        let doc = parser.parseFromString(htmlString, "text/html");
        let sizeChartEl = doc.querySelector("size-chart");
        if (sizeChartEl) {
          document.querySelector(".js_sizing_table").classList.remove("hidden");
          document.querySelector(".sizechart_studiosuit").innerHTML = sizeChartEl.innerHTML;
        } else {
          document.querySelector(".js_sizing_table").classList.add("hidden");
          console.log("Size chart not found");
        }
      }).catch((err) => console.error(err));
      if (trigger !== "initial") {
        if (options_not_disabled.length == 0) {
          setUrlParams(select2, product.variants.find((variant) => {
            return variant.title.includes(options[0].value);
          }), product);
        } else {
          setUrlParams(select2, availableVariants.find((variant) => {
            return variant.title.includes(options_not_disabled[0].value);
          }), product);
        }
      }
      options.forEach((option) => {
        if (option.getAttribute("data-set-by-url") === "true") ;
      });
      select2.addEventListener("change", (e) => {
        let variant = product.variants.find((variant2) => {
          return variant2.title.includes(e.target.value);
        });
        let option = e.target.querySelector(`option[data-id="${variant.id}"]`);
        console.log("selected variant", variant, select2, e.target, option);
        var option_html = option.innerHTML;
        pricingElement.innerHTML = pricing(
          renderDiscount(
            variant.price,
            discount,
            option_html.indexOf(window.pieces_text) > -1 ? true : false
          )
        ) + ' <span class="percentage">(' + discount + "%)</span><s>" + (option_html.indexOf(window.pieces_text) > -1 ? pricing(variant.price * 2) : pricing(variant.price)) + "</s>";
        setLocalstorage(variant);
        setUrlParams(select2, variant, product);
        if (variant.image) {
          handleProductImage(variant.image, imageLayer, variant.image_url);
        }
        if (prefSizeCheck(e.target.value)) {
          sessionStorage.setItem("studiosuite_pref_size", JSON.stringify(e.target.value.split("X")[0]));
        }
        if (variant.available == false || select2.querySelector(`option[value="${select2.value}"]`).hasAttribute("disabled") == true) {
          select2.closest("configurator-variant").querySelector("button.button-holder__button.button").classList.add("disabled");
        } else {
          select2.closest("configurator-variant").querySelector("button.button-holder__button.button").classList.remove("disabled");
        }
        window.updateSummaryPopup();
      });
      if (product) {
        nextButton.disabled = false;
        nextButton.classList.remove("disabled");
      }
      if (options_not_disabled.length == 0) {
        select2.closest("configurator-variant").querySelector("button.button-holder__button.button").classList.add("disabled");
      } else {
        select2.closest("configurator-variant").querySelector("button.button-holder__button.button").classList.remove("disabled");
      }
      let view_all_check = JSON.parse(sessionStorage.getItem("configuratorConfig")) != null ? JSON.parse(sessionStorage.getItem("configuratorConfig")).every((item) => item === null) : false;
      if (JSON.parse(sessionStorage.getItem("configuratorConfig")) == null || view_all_check) {
        document.querySelectorAll(".view_summary").forEach((view_summary) => {
          view_summary.style.display = "none";
        });
      } else {
        document.querySelectorAll(".view_summary").forEach((view_summary) => {
          view_summary.style.display = "block";
        });
      }
      let currentConfig = sessionStorage.getItem("configuratorConfig") ? JSON.parse(sessionStorage.getItem("configuratorConfig")) : [];
      if (currentConfig && currentConfig[4]) {
        console.log("ssssss");
        let extraProducts = currentConfig[4];
        let totalPrice = 0;
        Object.values(extraProducts).forEach((item) => {
          if (item && item.product_id) {
            let price = item.price;
            totalPrice += price;
            console.log("totalPrice ", totalPrice);
          }
        });
        let discounted = totalPrice - totalPrice * 0.2;
        let formattedDiscounted = pricing(discounted);
        let formattedOriginal = pricing(totalPrice);
        document.querySelectorAll(".js_price_extra")[document.querySelectorAll(".js_price_extra").length - 1].innerHTML = formattedDiscounted + "(20% off) <s>" + formattedOriginal + "</s>";
      }
    };
    const handleProductVariants = (product, trigger) => {
      console.log(product, " == product");
      let variants = product.variants;
      let optionsArray = ["90X200", "160X200", "180X200", "200X210", "135X200", "155X220", "200X200", "200X220", "240X220", "260X220", "140X220", "140X200", "60X70", "65X65", "50X75", "160X200X30", "180X200X30", "200X210X30", "50X160", "50X180", "90X200X30", "40X80", "50X70", "60X63", "80X80", "155X200", "135X200"];
      let currentOption = document.querySelector(".button-row__button input[checked]");
      let discountbase = document.querySelector("configurator-overview").dataset.baseDiscount;
      let discountextra = document.querySelector("configurator-overview").dataset.extraDiscount;
      let discount = currentOption.dataset.layer <= 3 ? discountbase : discountextra;
      let items = 0;
      let options = variants.map((variant) => {
        console.log(variant.option2, "variant.option2");
        if (optionsArray.includes(variant.option2.toUpperCase())) {
          items++;
          if (variant.available) ;
          return `<option value="${variant.option2}" data-old-price="${pricing(variant.price)}" data-id="${variant.id}" ${!variant.available ? "disabled" : null} ${variant.option2.includes("90X200X30") && variant.inventory_quantity <= 1 ? "disabled" : null} ${variant.option2.includes("140") && variant.inventory_quantity <= 1 && product.type != "Hoeslaken" ? "disabled" : null} ${variant.option2.includes("60X70") && variant.inventory_quantity <= 1 ? "disabled" : null} ${variant.option2.includes("65X65") && variant.inventory_quantity <= 1 ? "disabled" : null} ${variant.option2.includes("50X75") && variant.inventory_quantity <= 1 ? "disabled" : null} ${variant.option2.includes("50X70") && variant.inventory_quantity <= 1 ? "disabled" : null} ${variant.option2.includes("60X63") && variant.inventory_quantity <= 1 ? "disabled" : null}>${(variant.option2.includes("140") && product.type != "Hoeslaken") || variant.option2.toUpperCase().includes("80X80") || variant.option2.toUpperCase().includes("40X80") || variant.option2.toUpperCase().includes("50X70") || variant.option2.toUpperCase().includes("60X63") || variant.option2.toUpperCase().includes("60X70") || variant.option2.toUpperCase().includes("65X65") || variant.option2.toUpperCase().includes("50X75") || variant.option2.includes("90X200X30") || variant.option2.toLowerCase().includes("135x200") || variant.option2.toLowerCase().includes("155x220") ? variant.option2 + " " + window.pieces_text : variant.option2}</option>`;
        }
      });
      let firstAvailableVariant = variants.find((variant) => {
        return variant.available;
      });
      console.log(firstAvailableVariant, firstAvailableVariant, options);
      var option_html = options.find((option) => (option != undefined)? option.includes(firstAvailableVariant ? firstAvailableVariant.id : variants[0].id) : null ) || null;
      pricingElement.innerHTML = pricing(
        renderDiscount(
          firstAvailableVariant ? firstAvailableVariant.price : variants[0].price,
          discount,
          option_html != null ? option_html.indexOf(window.pieces_text) > -1 : multipleProducts(firstAvailableVariant ? firstAvailableVariant : variants[0], option_html)
        )
      ) + ' <span class="percentage">(' + discount + "%)</span><s>" + ((option_html != null ? option_html.indexOf(window.pieces_text) > -1 : multipleProducts(firstAvailableVariant ? firstAvailableVariant : variants[0], option_html)) ? pricing(firstAvailableVariant ? firstAvailableVariant.price * 2 : variants[0].price * 2) : pricing(firstAvailableVariant ? firstAvailableVariant.price : variants[0].price)) + "</s>";
      select.innerHTML = options.join("");
      if (items === 1) {
        select.style.backgroundImage = "none";
      }
      let currentConfig = sessionStorage.getItem("configuratorConfig") ? JSON.parse(sessionStorage.getItem("configuratorConfig")) : [];
      if (currentConfig && currentConfig[4]) {
        console.log("ssssss");
        let extraProducts = currentConfig[4];
        let totalPrice = 0;
        Object.values(extraProducts).forEach((item) => {
          if (item && item.product_id) {
            let price = item.price;
            totalPrice += price;
            console.log("totalPrice ", totalPrice);
          }
        });
        let discounted = totalPrice - totalPrice * 0.2;
        let formattedDiscounted = pricing(discounted);
        let formattedOriginal = pricing(totalPrice);
        document.querySelectorAll(".js_price_extra")[document.querySelectorAll(".js_price_extra").length - 1].innerHTML = formattedDiscounted + "(20% off) <s>" + formattedOriginal + "</s>";
      }
      handleVariantSelect(product, select, discount, trigger);
      handleProductImage(variants[0].image, imageLayer, variants[0].image_url);
    };
    const handleActiveButton = (button) => {
      let color = button.querySelector(".color");
      buttons.forEach((button2) => {
        button2.querySelector(".color").classList.remove("current-selected");
      });
      if (color) {
        color.classList.add("current-selected");
      }
    };
    const handleColorIndicator = (button) => {
      let colorIndicator = this.querySelector(".color-indicator__color");
      let color = button.dataset.color;
      if (color) {
        colorIndicator.innerHTML = color;
      }
    };
    const handleFallbackColor = () => {
      buttons.forEach((button) => {
        if (button.querySelector(".color").classList.contains("current-selected")) {
          handleColorIndicator(button);
        }
      });
    };
    buttons.forEach((button) => {
      button.addEventListener("click", (e) => {
        let productId = button.dataset.id ? button.dataset.id : null;
        let product = JSON.parse(products).find((p) => {
          return p.id === Number(productId);
        });
        handleProductVariants(product, "normal");
        handleActiveButton(button);
        handleColorIndicator(button);
        handleFallbackColor(e.target);
        let currentConfig = sessionStorage.getItem("configuratorConfig") ? JSON.parse(sessionStorage.getItem("configuratorConfig")) : [];
        if (currentConfig && currentConfig[4]) {
          console.log("ssssss");
          let extraProducts = currentConfig[4];
          let totalPrice = 0;
          Object.values(extraProducts).forEach((item) => {
            if (item && item.product_id) {
              let price = item.price;
              totalPrice += price;
              console.log("totalPrice ", totalPrice);
            }
          });
          let discounted = totalPrice - totalPrice * 0.2;
          let formattedDiscounted = pricing(discounted);
          let formattedOriginal = pricing(totalPrice);
          document.querySelectorAll(".js_price_extra")[document.querySelectorAll(".js_price_extra").length - 1].innerHTML = formattedDiscounted + "(20% off) <s>" + formattedOriginal + "</s>";
        }
        if (window.height_scroll != void 0) {
          window.height_scroll();
        }
      });
      button.addEventListener("mouseenter", () => {
        handleColorIndicator(button);
      });
      button.addEventListener("mouseleave", () => {
        handleFallbackColor();
      });
    });
    nextButton.addEventListener("click", (e) => {
      let nextLayer = nextButton.dataset.next;
      let currentLayer = nextButton.dataset.current;
      let nextStep = document.querySelector(`.layer-${nextLayer}`);
      let currentLabel = document.querySelector(`.layer-label-${currentLayer}`);
      let currentlabelwidth = document.querySelector(`.layer-label-${currentLayer}`).offsetWidth;
      let checkmark = document.querySelector(`.layer-label-${currentLayer} .icon-checkmark`);
      let overview = document.querySelector("configurator-overview");
      let newScrollPosition = currentlabelwidth + buttonRow.scrollLeft;
      if (Number(nextLayer) == 4) {
        overview.classList.remove("hidden");
        console.log("ddd");
        let selectedItems = JSON.parse(sessionStorage.getItem("configuratorConfig"));
        let filteredItems = selectedItems ? selectedItems.filter((selectedItem) => selectedItem !== null) : [];
        let selected_items = [];
        filteredItems.forEach((val) => {
          if (Object.entries(val)[0][1].extraProduct === true) {
            for (let i in val) {
              let v = val[i];
              if (v && v.product_title && v.option1 && v.option2) {
                selected_items.push({
                  title: v.product_title,
                  select_colour: v.full_option1,
                  select_size: v.full_option2
                });
              }
            }
          } else {
            selected_items.push({
              title: val.product_title,
              select_colour: val.full_option1,
              select_size: val.full_option2
            });
          }
        });
        window.dataLayer = window.dataLayer || [];
        let alreadyPushed = window.dataLayer.some(
          (entry) => {
            var _a;
            return entry.event === "configuratorItemsSelected" && JSON.stringify((_a = entry.ecommerce) == null ? void 0 : _a.items) === JSON.stringify(selected_items);
          }
        );
        if (!alreadyPushed) {
          window.dataLayer.push({
            event: "configuratorItemsSelected",
            ecommerce: {
              items: selected_items
            }
          });
        }
      }
      if (nextStep) {
        nextStep.checked = true;
        nextStep.classList.add("active");
        nextStep.parentElement.classList.remove("button-row__button--no-events");
        checkmark.classList.add("icon-checkmark--active");
        currentLabel.classList.add("handled");
        buttonRow.scroll({
          top: 0,
          left: newScrollPosition,
          behavior: "smooth"
        });
        if (nextStep.closest(".button-row__button.hidden") != null) {
          document.querySelector(".layer-5").checked = true;
          document.querySelector(".layer-5").classList.add("active");
          document.querySelector(`.layer-label-${5} .icon-checkmark`).classList.toggle("icon-checkmark--active");
        }
      }
      if ($(window).width() <= 768) {
        console.log("mobile");
        window.scrollTo({
          top: 132,
          left: 0,
          behavior: "smooth"
        });
      } else {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        });
      }
    });
    previousButton === null || previousButton === void 0 ? void 0 : previousButton.addEventListener("click", (e) => {
      let nextLayer = previousButton.dataset.next;
      let currentLayer = previousButton.dataset.current;
      let nextStep = document.querySelector(`.layer-${nextLayer}`);
      let currentLabel = document.querySelector(`.layer-label-${currentLayer}`);
      let currentlabelwidth = document.querySelector(`.layer-label-${currentLayer}`).offsetWidth;
      let checkmark = document.querySelector(`.layer-label-${currentLayer} .icon-checkmark`);
      let overview = document.querySelector("configurator-overview");
      let newScrollPosition = currentlabelwidth + buttonRow.scrollRight;
      if (Number(nextLayer) == 4) {
        overview.classList.remove("hidden");
        let selectedItems = JSON.parse(sessionStorage.getItem("configuratorConfig"));
        let filteredItems = selectedItems ? selectedItems.filter((selectedItem) => selectedItem !== null) : [];
        let selected_items = [];
        filteredItems.forEach((val) => {
          if (Object.entries(val)[0][1].extraProduct === true) {
            for (let i in val) {
              let v = val[i];
              if (v && v.product_title && v.option1 && v.option2) {
                selected_items.push({
                  title: v.product_title,
                  select_colour: v.full_option1,
                  select_size: v.full_option2
                });
              }
            }
          } else {
            selected_items.push({
              title: val.product_title,
              select_colour: val.full_option1,
              select_size: val.full_option2
            });
          }
        });
        window.dataLayer = window.dataLayer || [];
        let alreadyPushed = window.dataLayer.some(
          (entry) => {
            var _a;
            return entry.event === "configuratorItemsSelected" && JSON.stringify((_a = entry.ecommerce) == null ? void 0 : _a.items) === JSON.stringify(selected_items);
          }
        );
        if (!alreadyPushed) {
          window.dataLayer.push({
            event: "configuratorItemsSelected",
            ecommerce: {
              items: selected_items
            }
          });
        }
      }
      if (nextStep) {
        nextStep.checked = true;
        nextStep.classList.remove("active");
        nextStep.parentElement.classList.remove("button-row__button--no-events");
        checkmark.classList.remove("icon-checkmark--active");
        currentLabel.classList.remove("handled");
        buttonRow.scroll({
          top: 0,
          left: newScrollPosition,
          behavior: "smooth"
        });
        if (nextStep.closest(".button-row__button.hidden") != null) {
          document.querySelector(".layer-5").checked = true;
          document.querySelector(".layer-5").classList.add("active");
          document.querySelector(`.layer-label-${5} .icon-checkmark`).classList.toggle("icon-checkmark--active");
        }
      }
    });
    if (colorGrid) {
      handleColorScroll(colorGrid);
    }
    const handleActiveURLParams = (trigger) => {
      let url = new URL(window.location.href);
      url.searchParams.forEach((value, key) => {
        if (param === key) {
          let productId = value.split("-")[0];
          let variantId = value.split("-")[1];
          let product = JSON.parse(products).find((p) => {
            return p.id === Number(productId);
          });
          let variant = product === null || product === void 0 ? void 0 : product.variants.find((v) => {
            return v.id === Number(variantId);
          });
          handleProductVariants(product, trigger);
          let activeProduct = this.querySelector(`.colors-grid__item[data-id="${productId}"]`);
          let color = activeProduct.querySelector(".color");
          color === null || color === void 0 ? void 0 : color.classList.add("current-selected");
          let _select = this.querySelector(".variant-select");
          let options = _select.querySelectorAll("option");
          setTimeout(() => {
            options.forEach((option) => {
              if (option.value.includes(variant.option2)) {
                option.selected = true;
                option.setAttribute("data-set-by-url", true);
                _select.dispatchEvent(new Event("change", { bubbles: true }));
              }
            });
          }, 750);
        }
      });
    };
    setTimeout(() => {
      handleActiveURLParams("initial");
    }, 50);
  }
}
if (customElements.get("configurator-variant") === void 0) {
  customElements.define("configurator-variant", ConfiguratorVariant);
}
